import FVector from '@data/geometry/FVector';
import { GeometryUtils } from '@data/geometry/GeometryUtils';
import * as THREE from 'three';

export function isEdgeBlocked(
    p1: FVector,
    p2: FVector,
    perimeter: FVector[],
    avgDirection: FVector,
    visibilityLoops: FVector[][] = [perimeter]
): boolean {
    const avgDirXY = new THREE.Vector3(avgDirection.x, avgDirection.y, 0).normalize();
    const dir = new THREE.Vector2(avgDirXY.x, avgDirXY.y).normalize();
    const p1v = new THREE.Vector2(p1.x, p1.y);
    const p2v = new THREE.Vector2(p2.x, p2.y);

    const p1Blocked = visibilityLoops.some((loop) =>
        GeometryUtils.rayHitsPolygon(
            p1v,
            dir,
            loop.map((p) => new THREE.Vector2(p.x, p.y)),
            p1v,
            p2v
        )
    );
    const p2Blocked = visibilityLoops.some((loop) =>
        GeometryUtils.rayHitsPolygon(
            p2v,
            dir,
            loop.map((p) => new THREE.Vector2(p.x, p.y)),
            p1v,
            p2v
        )
    );

    return p1Blocked || p2Blocked;
}

export function isEdgeFacing(
    p1: FVector,
    p2: FVector,
    perimeter: FVector[],
    avgDirection: FVector,
    visibilityLoops: FVector[][] = [perimeter]
): boolean {
    return !isEdgeBlocked(p1, p2, perimeter, avgDirection, visibilityLoops);
}
